import api from './api';

export const url = 'send/code/wa';

const sendCodeWaGet = async (): Promise<void> => {
  return await api.get(url, true);
};

export default sendCodeWaGet;
